import React from "react";
import PropTypes from "prop-types";
import Text from "@/bit/components/next13.components.text";
import style from "./style";

const Header = ({ title, subTitle }) => {
  return (
    <>
      <div className="streaming-header">
        {title && <Text {...title} cyData="StreamingPlatforms Title"/>}
        {subTitle && <Text {...subTitle} cyData="StreamingPlatforms SubTitle" />}
      </div>
      <style jsx>{style}</style>
    </>
  );
};

export default Header;

Header.propTypes = {};
Header.defaultProps = {};
